export var LOAN_CATEGORIES;
(function (LOAN_CATEGORIES) {
    LOAN_CATEGORIES["RENOVATION"] = "886";
    LOAN_CATEGORIES["RENOVATION_STRING"] = "RENOVATION";
    LOAN_CATEGORIES["REAL_ESTATE_FINANCING"] = "999999999";
    LOAN_CATEGORIES["REAL_ESTATE_FINANCING_STRING"] = "REAL_ESTATE_FINANCING";
})(LOAN_CATEGORIES || (LOAN_CATEGORIES = {}));
export var KNOWN_QUERY_PARAMS;
(function (KNOWN_QUERY_PARAMS) {
    KNOWN_QUERY_PARAMS["CATEGORY"] = "category";
    KNOWN_QUERY_PARAMS["AMOUNT"] = "amount";
    KNOWN_QUERY_PARAMS["DURATION"] = "duration";
    KNOWN_QUERY_PARAMS["PLACEMENT_ID"] = "placementId";
    KNOWN_QUERY_PARAMS["UTM_SOURCE"] = "utm_source";
    KNOWN_QUERY_PARAMS["UTM_MEDIUM"] = "utm_medium";
    KNOWN_QUERY_PARAMS["UTM_CAMPAIGN"] = "utm_campaign";
    KNOWN_QUERY_PARAMS["UTM_TERM"] = "utm_term";
    KNOWN_QUERY_PARAMS["SMAVA_CUSTOMER_NUMBER"] = "smava_customer_number";
    KNOWN_QUERY_PARAMS["PREVENT_SWITCH"] = "preventSwitch";
    KNOWN_QUERY_PARAMS["SWITCHING_BUCKET"] = "switchingBucket";
    KNOWN_QUERY_PARAMS["REDIRECTED_FROM_MR1"] = "redirectionFromMr1";
    KNOWN_QUERY_PARAMS["IS_TEST_MODE"] = "test";
    KNOWN_QUERY_PARAMS["IS_OPTANON_DEBUG_MODE"] = "debugOptanon";
    // JUST for communication between our app and embedded IS24 for MR2
    KNOWN_QUERY_PARAMS["PARTNER_TRACKING"] = "partnerTracking";
    // to jump through blocking that was set via smf-650__block_own_advisory_flow feature
    KNOWN_QUERY_PARAMS["IS_BLOCKING_IGNORED"] = "ignoreBlocking";
    KNOWN_QUERY_PARAMS["CRM_LEAD"] = "crmLead";
})(KNOWN_QUERY_PARAMS || (KNOWN_QUERY_PARAMS = {}));
